import { Helpers } from '../../helpers';
import { IProjectType } from '../../interfaces/iproject-type';
import { AssetMappingConfiguration } from '../asset-mapping-configuration';
import { BudgetAdjustment } from '../budget-adjustment';
import { BudgetCategory } from '../budget-category';
import { CostCodeCostTypeProjectCombination } from '../cost-code-cost-type-project-combination';
import { DetailedBudgetCategory } from '../detailed-budget-category';
import { MajorMilestoneProjectTypeVisibility } from '../major-milestone-project-type-visibility';
import { Project } from '../project';
import { ProjectAttribute } from '../project-attribute';
import { ProjectEstimateVariable } from '../project-estimate-variable';
import { ProjectParameterConfiguration } from '../project-parameter-configuration';
import { ProjectSubType } from '../project-sub-type';
import { ProjectSuperType } from '../project-super-type';
import { ProjectTemplate } from '../project-template';
import { ProjectTypeScreenBehavior } from '../project-type-screen-behavior';
import { ResourceCostCodeCostType } from '../resource-cost-code-cost-type';
import { StandardConfiguration } from '../standard-configuration';

export class ProjectTypeBase {
  ProjectTypeId: number;
  Description: string;
  SortOrder: number | null;
  Abbr: string | null;
  ProjectSuperTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetMappingConfigurations_ProjectType?: Array<AssetMappingConfiguration> | null;
  BudgetAdjustments_ProjectType?: Array<BudgetAdjustment> | null;
  BudgetCategories_ProjectType?: Array<BudgetCategory> | null;
  CostCodeCostTypeProjectCombinations_ProjectType?: Array<CostCodeCostTypeProjectCombination> | null;
  DetailedBudgetCategories_ProjectType?: Array<DetailedBudgetCategory> | null;
  MajorMilestoneProjectTypeVisibilities_ProjectType?: Array<MajorMilestoneProjectTypeVisibility> | null;
  ProjectAttributes_ProjectType?: Array<ProjectAttribute> | null;
  ProjectEstimateVariables_ProjectType?: Array<ProjectEstimateVariable> | null;
  ProjectParameterConfigurations_ProjectType?: Array<ProjectParameterConfiguration> | null;
  Projects_ProjectType?: Array<Project> | null;
  ProjectSubTypes_ProjectType?: Array<ProjectSubType> | null;
  ProjectTemplates_ProjectType?: Array<ProjectTemplate> | null;
  ProjectTypeScreenBehaviors_ProjectType?: Array<ProjectTypeScreenBehavior> | null;
  ResourceCostCodeCostTypes_ProjectType?: Array<ResourceCostCodeCostType> | null;
  StandardConfigurations_ProjectType?: Array<StandardConfiguration> | null;
  ProjectSuperType?: ProjectSuperType;

  constructor(item?: IProjectType) {
    if (item) {

      this.ProjectTypeId = item.ProjectTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Abbr = item.Abbr;
      this.ProjectSuperTypeId = item.ProjectSuperTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetMappingConfigurations_ProjectType = Helpers.createClassArray(AssetMappingConfiguration, item.AssetMappingConfigurations_ProjectType);
      this.BudgetAdjustments_ProjectType = Helpers.createClassArray(BudgetAdjustment, item.BudgetAdjustments_ProjectType);
      this.BudgetCategories_ProjectType = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_ProjectType);
      this.CostCodeCostTypeProjectCombinations_ProjectType = Helpers.createClassArray(CostCodeCostTypeProjectCombination, item.CostCodeCostTypeProjectCombinations_ProjectType);
      this.DetailedBudgetCategories_ProjectType = Helpers.createClassArray(DetailedBudgetCategory, item.DetailedBudgetCategories_ProjectType);
      this.MajorMilestoneProjectTypeVisibilities_ProjectType = Helpers.createClassArray(MajorMilestoneProjectTypeVisibility, item.MajorMilestoneProjectTypeVisibilities_ProjectType);
      this.ProjectAttributes_ProjectType = Helpers.createClassArray(ProjectAttribute, item.ProjectAttributes_ProjectType);
      this.ProjectEstimateVariables_ProjectType = Helpers.createClassArray(ProjectEstimateVariable, item.ProjectEstimateVariables_ProjectType);
      this.ProjectParameterConfigurations_ProjectType = Helpers.createClassArray(ProjectParameterConfiguration, item.ProjectParameterConfigurations_ProjectType);
      this.Projects_ProjectType = Helpers.createClassArray(Project, item.Projects_ProjectType);
      this.ProjectSubTypes_ProjectType = Helpers.createClassArray(ProjectSubType, item.ProjectSubTypes_ProjectType);
      this.ProjectTemplates_ProjectType = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_ProjectType);
      this.ProjectTypeScreenBehaviors_ProjectType = Helpers.createClassArray(ProjectTypeScreenBehavior, item.ProjectTypeScreenBehaviors_ProjectType);
      this.ResourceCostCodeCostTypes_ProjectType = Helpers.createClassArray(ResourceCostCodeCostType, item.ResourceCostCodeCostTypes_ProjectType);
      this.StandardConfigurations_ProjectType = Helpers.createClassArray(StandardConfiguration, item.StandardConfigurations_ProjectType);
      this.ProjectSuperType = new ProjectSuperType(item.ProjectSuperType);
    }
  }
}